// extracted by css-extract-rspack-plugin
export default {"heading":"vI2A3OpNyX0J9H3t","truncate":"Q17vgbTvSpEoQcJb","small":"DI8W_RbV6ckVRFY3","medium":"kKkmyot3bCUun65C","large":"xZLjTGXN8CkMZsQr","bold":"vh11CoGwpMYb5iXI"};